import React, { useState } from "react";

import {
	ChevronDownIcon,
	ChangeableCheckbox,
} from "../../../../../resource/icons";
import Houses from "./houses.jsx";

const Street = ({ street }) => {
	const [streetOpened, setStreetOpened] = useState(false);

	return (
		<>
			<div className="branch " onClick={() => setStreetOpened(!streetOpened)}>
				<label
					onClick={(e) => {
						e.stopPropagation();
					}}
				>
					<input
						type="checkbox"
						className="true-checkbox"
						checked={street.checked()}
						onChange={(e) => street.onSelectChange(e)}
					/>
					<ChangeableCheckbox
						indeterminateCheckBox={street.indeterminate()}
						checked={street.checked()}
						className="checkbox"
					/>
				</label>
				<span>Улица {street.street}</span>
				<div className="spacer" />
				<ChevronDownIcon className={streetOpened && "chevron-opened"} />
			</div>
			{streetOpened && <Houses houses={street.houses} />}
		</>
	);
};

export default Street;
